import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
export const useInSidePanelLayoutExperiment = () => {
  const {
    isAssignedToVariant: isAssignedToVariantACQ172,
    isAssignedToSpecificVariant: isAssignedToSpecificVariantACQ172
  } = useExperiment(ExperimentKeys.ACQ0172, TrackWhen.never);
  const {
    isAssignedToVariant: isAssignedToVariantACQ173
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const isAssignedToACQ172VariantB = isAssignedToSpecificVariantACQ172(ExperimentParameterGroup.Variant_B);
  const isAssignedToACQ172VariantA = isAssignedToSpecificVariantACQ172(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ172OrACQ173Variants = isAssignedToVariantACQ172() || isAssignedToVariantACQ173();
  return {
    isInSidePanelLayoutExperiment: isAssignedToACQ172OrACQ173Variants,
    isUsingNewLayout: isAssignedToACQ172VariantB || isAssignedToACQ172VariantA
  };
};